<template>
  <div id="ConfigOverview">
    <h4>{{ lang.W00000 }}</h4>
    <div class="wizard-table-container">
      <!-- Header Row -->
      <div class="wizard-table-header">
        <div>{{ lang.W00001 }}</div>
        <div>{{ lang.W00002 }}</div>
        <div>{{ lang.W00003 }}</div>
        <div></div>
        <div></div>
      </div>
      <div class="wizard-table-body">
        <div
          v-for="config in configurations" 
          :key="config.ConfigurationGuid"
          class="wizard-table-row"
        >
          <div class="table-cell">{{ config.Title }}</div>
          <div class="table-cell">{{ config.Status }}</div>
          <div class="table-cell">{{ globals.getLocalizedDateTimeFromUtcIsoTimestamp(config.LastUpdate) }}</div>
          <div class="table-cell">
            <router-link :to="`/config/${config.ConfigurationGuid}`" class="resume-btn">
              <span v-if="config.Status == 'finished'">{{ lang.W00089 }}</span>
              <span v-else>{{ lang.W00004 }}</span>
              <!-- <i class="material-icons md-24">keyboard_return</i> -->
            </router-link>
          </div>
          <div class="table-cell delete-config-btn-td">
            <button 
              class="delete-config-btn"
              @click="openConfirmationDialog(config.ConfigurationGuid)" 
              :disabled="config.Status == 'finished'"
            >
              <i class="material-icons md-24">delete</i>            
            </button>
          </div>
        </div>
      </div>
    </div>

    <router-link id="new-config-btn" :to="`/config/new`">
      <i class="material-icons md-24">add</i>
      <span>{{ lang.W00008 }}</span>
    </router-link>
    <ConfirmationDialog
      dialogId="deleteConfigConfirmationDialog"
      confirmationTitle="Do you want really to delete the configuration?"
      yesButtonText="Delete"
      noButtonText="Cancel"
      :showDialog="showDeleteConfigConfirmationDialog"
      @onYesConfirmation="onYesConfirmation"
      @onNoConfirmation="onNoConfirmation"
      @dialogClosed="onConfirmationDialogClosed"
    ></ConfirmationDialog>
  </div>
</template>

<script>
import "../../styles/audi-steps.css";
import wizardService from '../../services/WizardService';
import ConfirmationDialog from '../Tools/Dialogs/ConfirmationDialog'

export default {
  name: "ConfigOverview",
  components: { ConfirmationDialog },
  data() {
    return {
      configurations: null,
      showDeleteConfigConfirmationDialog: false,
      configurationGuid_toBeDeleted: null,
      lang: {
        W00000: "Configuration Overview",
        W00001: "Title",
        W00002: "Status",
        W00003: "Last update",
        W00004: "Resume",
        W00005: "In progress",
        W00006: "Pending",
        W00007: "Finished",
        W00008: "New",

        W00089: "View"
      }
    }
  },
  mounted() {
    if (this.globals.selectedLanguage) { 
      this.globals.getLanguageStrings(this);
    }

    this.getConfigs();
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  methods: {
    openConfirmationDialog(configurationGuid) {
      this.configurationGuid_toBeDeleted = configurationGuid;
      this.showDeleteConfigConfirmationDialog = true;
    },
    async onYesConfirmation() {
      await wizardService.deleteConfiguration(this.configurationGuid_toBeDeleted);
      this.showDeleteConfigConfirmationDialog = false;
      this.configurationGuid_toBeDeleted = null;
      this.getConfigs();
    },
    onNoConfirmation() {
      this.showDeleteConfigConfirmationDialog = false;
      this.configurationGuid_toBeDeleted = null;
    },
    onConfirmationDialogClosed() {
      this.showDeleteConfigConfirmationDialog = false;
      this.configurationGuid_toBeDeleted = null;
    },
    async getConfigs() {
      let res = await wizardService.readConfigurations();
      if(res.length && res.length > 0) this.configurations = res;
    },
  }
}
</script>

<style scoped>
#ConfigOverview {
  width: 100%;
  height: calc(100% - 20px);
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.wizard-table-header {
  grid-template-columns: 1fr 1fr 1fr .5fr .5fr;
}
.wizard-table-row {
  grid-template-columns: 1fr 1fr 1fr .5fr .5fr;
}
.wizard-table-container {
  min-width: 80vw;
  max-height: 75vh;
}

#new-config-btn {
  display: block;
  padding: 16px 24px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
  background: var(--color-primary);
  color: white;
  width: 200px;
  margin-top: 16px;
  text-decoration: none;

  &:hover:not(:disabled) {
    opacity: 0.8;
  }
}
.resume-btn {
  display: block;
  padding: 8px 12px;
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.2s;
  background: var(--color-primary);
  color: white;
  text-decoration: none;

  &:hover:not(:disabled) {
    opacity: 0.8;
    text-decoration: none !important;
  }
}
.delete-config-btn-td {
  display: flex;
  align-items: center;
  justify-content: center;
}
.delete-config-btn {
  background: transparent;
  border: none;
  display: flex;
}
.delete-config-btn:disabled i {
  color: #e0e0e0;
}
</style>


// WEBPACK FOOTER //
// ConfigOverview.vue?4020f9b4